// Runtime feature flags from the backend (GET /api/v1/meta), loaded once on
// entry. The ban UI reads `enforcementEnabled` so its copy is honest: while
// REMEDIATION_ENABLED is off a ban is "recorded only / no firewall change";
// once it's on, active bans are published to the ban agent and the warnings get
// real teeth (especially when banning your own IP).

import { appInfo } from './api';

let _remediation = $state(false);
let _banWorkflow = $state(true);
let _loaded = $state(false);

export const features = {
	/** REMEDIATION_ENABLED on the backend — the enforcement feed is live. */
	get enforcementEnabled(): boolean {
		return _remediation;
	},
	get banWorkflowEnabled(): boolean {
		return _banWorkflow;
	},
	get loaded(): boolean {
		return _loaded;
	},
};

let _attempted = false;
let _inflight = false;

export async function loadFeatures(force = false): Promise<void> {
	if (_inflight) return;
	if (_attempted && _loaded && !force) return;
	_inflight = true;
	try {
		const m = await appInfo.meta();
		_remediation = !!m.remediation_enabled;
		_banWorkflow = !!m.ban_workflow_enabled;
		_loaded = true;
		_attempted = true;
	} catch {
		// Not logged in / unreachable — leave defaults (safe: enforcement off).
	} finally {
		_inflight = false;
	}
}

export function resetFeatures(): void {
	_remediation = false;
	_banWorkflow = true;
	_loaded = false;
	_attempted = false;
}
